import React, { FC, ReactElement, useContext } from 'react'
import { Location, NavigateFunction, useLocation, useNavigate } from 'react-router'
import CLanguageHandler from '../../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../../../../React/Common/Contexts'
import { RoundedButton } from '../../../Atoms/RoundedButton/RoundedButton'
import { ChangeLangLanguage } from '../../../../../../i18n'
import { getAuthURL } from '../../../../Constants/Constants'
import { setSessionLanguage } from '../../../../../React/Common/API/LanguageAPI'
import { displayError } from '../../../../../React/Common/Utils/Messages'
import { LOCALE_COOKIE } from '../../../Molecules/LoginForm/Constants/Constants'
import { deleteCookie, setCookie } from '../../../../../NonReact/utils/StorageUtils'
import { performAuthOutflowRouting } from '../../../../Utilities/RoutingUtils'
import { moveToURL } from '../../../../../NonReact/constants/LocationUtils'
import { useBranding } from '../../../../../React/Common/Hooks/useBranding'
import { Branding } from '../../../../../React/Common/API/BrandingAPI'

type Props = {
    selectedLanguage: string
    rememberLanguage: boolean
}

export const FooterActions: FC<Props> = ({ selectedLanguage, rememberLanguage }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    const location: Location = useLocation()
    const navigate: NavigateFunction = useNavigate()
    const branding: Nullable<Branding> = useBranding()

    return (
        <div className='cl-footer'>
            <RoundedButton type='button' onClick={(): void => moveToURL(getAuthURL())}>
                {language.get(ChangeLangLanguage.ChangeLang_Buttons_Cancel)}
            </RoundedButton>
            <RoundedButton
                type='button'
                onClick={(): void => {
                    setSessionLanguage(selectedLanguage)
                        .then((): void => {
                            if (rememberLanguage) {
                                setCookie(LOCALE_COOKIE, selectedLanguage)
                            } else {
                                deleteCookie(LOCALE_COOKIE)
                            }

                            language.setLanguage(selectedLanguage)
                            performAuthOutflowRouting(navigate, location, branding)
                        })
                        .catch(displayError)
                }}
            >
                {language.get(ChangeLangLanguage.ChangeLang_Buttons_Apply)}
            </RoundedButton>
        </div>
    )
}
